import { AuthGuard } from 'src/app/core/guards/auth-guard/auth.guard';
import {
  BookingsRouteSegments,
  DashboardRouteSegments,
  EnquiriesRouteSegments,
  InspirationRouteSegments,
  JourneysRouteSegments,
  PaymentsRoutePaths,
  PaymentsRouteSegments,
} from 'src/app/shared/constants';
import { createCaseInsensitiveRouteMatcher } from 'src/app/shared/helpers';
import { PaymentsBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/payments-breadcrumb-resolver';
import { networkGuard } from 'src/app/core/guards/network/network.guard';
import { noNetworkGuard } from 'src/app/core/guards/no-network.guard';
import { Routes } from '@angular/router';
import { NotFoundComponent } from 'src/app/pages/not-found/not-found.component';
import { DashboardBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/dashboard-breadcrumb-resolver';
import { SettingsBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/settings-breadcrumb-resolver';
import { MyAccountBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/my-account-breadcrumb-resolver';
import { BookingsBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/bookings-breadcrumb-resolver';
import { EnquiriesBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/enquiries-breadcrumb-resolver';
import { InspirationBreadcrumbResolver } from 'src/app/core/resolvers/breadcrumb-resolver/inspiration-breadcrumb-resolver';
import { inspirationGuard } from 'src/app/core/guards/inspiration/inspiration.guard';
import { paymentsEnabledGuard } from 'src/app/core/guards/payments-enabled/payments-enabled.guard';

export const APP_SHELL_ROUTES: Routes = [
  {
    path: DashboardRouteSegments.Dashboard,
    canActivate: [AuthGuard],
    loadComponent: () => import('../../pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
    data: { breadcrumbResolver: DashboardBreadcrumbResolver },
  },
  {
    path: BookingsRouteSegments.Bookings,
    canActivate: [AuthGuard],
    loadChildren: () => import('../../pages/bookings/bookings.routes').then((r) => r.routes),
    data: { breadcrumbResolver: BookingsBreadcrumbResolver },
  },
  // Backwards compatibility: old booking pages were under "Journey".
  {
    path: JourneysRouteSegments.Journey,
    redirectTo: BookingsRouteSegments.Bookings,
  },
  {
    path: EnquiriesRouteSegments.Enquiries,
    canActivate: [AuthGuard],
    data: { breadcrumbResolver: EnquiriesBreadcrumbResolver },
    loadChildren: () => import('../../pages/enquiries/enquiries.routes').then((r) => r.routes),
  },
  {
    path: 'MyAccount',
    canActivate: [AuthGuard],
    loadComponent: () => import('../../pages/my-account/my-account.component').then((c) => c.MyAccountComponent),
    canMatch: [networkGuard],
    data: { breadcrumbResolver: MyAccountBreadcrumbResolver },
  },
  {
    path: PaymentsRoutePaths.maintenance,
    loadComponent: () =>
      import('../../pages/payments-maintenance/payments-maintenance.component').then(
        (c) => c.PaymentsMaintenanceComponent,
      ),
    pathMatch: 'full',
    canActivate: [paymentsEnabledGuard],
  },
  {
    matcher: createCaseInsensitiveRouteMatcher([PaymentsRouteSegments.payments]),
    loadChildren: () => import('../../pages/payments/payments.routes').then((r) => r.routes),
    canActivate: [paymentsEnabledGuard],
    canMatch: [networkGuard],
    data: { breadcrumbResolver: PaymentsBreadcrumbResolver },
  },

  {
    path: 'Settings',
    canActivate: [AuthGuard],
    loadComponent: () => import('src/app/pages/settings/settings.component').then((m) => m.SettingsComponent),
    data: { breadcrumbResolver: SettingsBreadcrumbResolver },
  },
  {
    path: 'NoNetwork',
    loadComponent: () => import('src/app/pages/no-network/no-network.component').then((m) => m.NoNetworkComponent),
    canActivate: [noNetworkGuard],
  },
  {
    path: 'Honeymoon/Find',
    redirectTo: 'Payments/Honeymoon',
    pathMatch: 'full',
  },
  {
    path: 'Honeymoon',
    redirectTo: 'Payments/Honeymoon',
    pathMatch: 'full',
  },
  {
    path: InspirationRouteSegments.Inspiration,
    canActivate: [AuthGuard, inspirationGuard],
    data: { breadcrumbResolver: InspirationBreadcrumbResolver },
    loadChildren: () => import('../../pages/inspiration/inspiration.routes').then((r) => r.routes),
  },
  {
    path: '',
    redirectTo: DashboardRouteSegments.Dashboard,
    pathMatch: 'full',
  },
  {
    path: '**',
    canActivate: [AuthGuard],
    component: NotFoundComponent,
  },
];
